import { ProjectType, PictureDetail } from '../../redux/sagaProject/IProjectDetail';
import { IDropdownData ,IDropdown} from 'redux/utility/IAdvanceSearch';
import { SaleAgent, PropertyType } from 'redux/sagaReport/IPropertyReport';
import { IBuyerInformation } from 'redux/sagaOffer/IOffer';

/* tslint:disable */
export enum EPropertyListType {
    MYPROPERTY = 'myproperty',
    ALLPROPERTY = 'allproperty',
    ARCHIVEPROPERTY = 'archive',
    OFFERPROPERTY = 'offer',
    CONTRACTPROPERTY = 'contract',
    DEEDPROPERTY = 'deed',
}

export interface PropertyDescriptionResponse {
    propertyId: number,
    classId: number,
    caption: any,
    renovation: any,
    gallar: any,
    advertising: any,
    adCounter: number,
    openHouseTitle: any,
    openHouseText: any,
    openHouseDate: Date,
    openHouseStartTime: Date,
    openHouseEndTime: Date,
    isAdvertised: boolean,
    standardText: any,
    propertyPortals: Portal[];
    sentToWeb: boolean;
}

export interface Property {
    propertyImage?: any;
    saleOrRent: string;
    propertyTitle: string;
    propertyAddress: string;
    propertyId: number;
    size: number;
    propertyType: string;
    propertyTypeId: number;
    propertyTypeIds: number[];
    price: number;
    totalRooms: number;
    salesRepresentativeId: string;
    salesRepresentative: string;
    onWebStatus: string;
    bathRoom: number;
    bedRoom: number;
    landSize: number;
    minimumPrice: number;
    projectName: string;
    propertySource?: any;
    restidentialOrCommercial: string;
    unitType?: any;
    mainRegId: string;
    province: string;
    district: string;
    area: string;
    zoneId?: number;
    zoneName?: any;
    propertyStatus?: any;
    propertyStatusId: number;
    featured: string;
    inStorage: boolean;
    isFeatured: boolean;
    isDeleted: boolean;
    isProject: boolean;
    hasOffer: boolean;
    hasContract: boolean;
    hasDeed: boolean;
    key: string;
    owner: string;
    caption: string;
    modifiedOn: Date;
    modifiedOnText: string;
    propertyPicturePath: string;
    houseNumber: string;
    jsonProjectName: any;
}

export interface Province {
    id: number;
    code: string;
    name: string;
    countryCode: string;
}

export interface District {
    id: number;
    code: string;
    regionCode: string;
    name: string;
}

export interface Area {
    id: number;
    code: string;
    regionCode: number;
    townId: number;
    name: string;
    countryCode: string;
}

export interface Zone {
    zoneId: number;
    zoneName: string;
}

export interface PropertyStatus {
    id: number;
    statusName: string;
}

export interface SelectedColumn {
    masterId: number;
    name: string;
    sequence: number;
    columnKey: string;
    isFixColumn: boolean;
}

export interface YesNoOption {
    name: string;
    value: string;
}

export interface GetPropertyListResponse {
    properties: Property[];
    provinces: Province[];
    districts: District[];
    areas: Area[];
    zones: Zone[];
    projectNames: string[];
    propertyTypes: PropertyType[];
    propertyTypesExcludePrefix: PropertyType[];
    propertyStatus: PropertyStatus[];
    saleOrRent: string[];
    selectedColumn: SelectedColumn[];
    featured: YesNoOption[];
    onWeb: YesNoOption[];
    agentIsolation: boolean;
    saleAgents: SaleAgent[];
    propertySources: IDropdownData[];
    isRestrictedExport: boolean;
    portals: IDropdownData[];
    selectedPortalProperties: SelectedPortalProperty[];
    defaultList: number;
}

export interface PropertyAsset {
    assetId: number;
    propertyId: number;
    regId: string;
    size: number;
    mhl: string;
    nh: string;
    nr: string;
    yearBuilt: string;
    yearComplete?: any;
    houseAppraisal: number;
    fireAppraisal: number;
    usageNameId: number;
    buildingMaterialId: number;
    landAppraisal: number;
}

export interface Portal {
    id: number;
    name: string;
    officeId: number;
    senderId: string;
    senderType: string;
    portalId: number;
    isEnabled: boolean;
    key: string;
    secret: string;
    email: string;
    url: string;
    isCsEnabled: boolean;
    isPublic: boolean;
    isDeleted: boolean;
    isDefault: boolean;
    propertyType?: any;
    officeName: string;
    country: string;
    databaseName: string;
    installedUrl: string;
    webPortalName: string;
    timeInterval: number;
    isSelected: boolean;
    linkUrl: string;
    viewCount: number;
    isInProgress: boolean;
}

export interface Encumbrance {
    propertyId: number;
    fileNo: string;
    encumbranceId: number;
}

export interface PropertyDetail {
    bedrooms: number;
    livingRooms: number;
    balconies: number;
    laundries: number;
    laundriesDesc: string;
    balconiesDesc: string;
    management: boolean;
    showHeating: boolean;
    electricity: boolean;
    cleaningJoint: boolean;
    janitorSalary: boolean;
    cleaningWaste: boolean;
    ownerInsurance: boolean;
    rentId: number;
    rentIndex?: any;
    rentFee?: any;
    rentPeriod?: any;
    paymentFrequency?: any;
    insurance?: any;
    insuranceAlt?: any;
    electricityIncluded?: any;
    waterIncluded?: any;
    heatingIncluded?: any;
    otherServices?: any;
    rentFrom?: any;
    rentTill?: any;
    premisesLength: number;
    premisesWidth: number;
    houseLength: number;
    houseWidth: number;
    floorArea: number;
    loftArea: number;
    floorPlateCapacity: number;
    ridgeHeight: number;
    wallHighest: number;
    wallLowest: number;
    sizeCubic: number;
    drivethroughDoors?: any;
    drivethroughDoorHeight: number;
    roof?: any;
    parkingSpaces?: any;
    buildingRight: number;
    zone?: any;
    hasGroundfloor: boolean;
    rentPrice: number;
    rentIncome: number;
    cIndex?: any;
    annulment?: any;
    loadingDoor?: any;
    propertyPicture: string;
    features: any[];
    propertyAssets: PropertyAsset[];
    portals: Portal[];
    fmrUrl: string;
    encumbrances: Encumbrance[];
    propertyId: number;
    classId: number;
    title: string;
    address: string;
    address2: string;
    windowsId: number;
    windows: string;
    enWindows: string;
    deliveryId: number;
    delivery: string;
    enDelivery: string;
    price: number;
    postaladdress: string;
    postaladdress2: string;
    postaladdress3: string;
    entranceId: number;
    entrance: string;
    enEntrance: string;
    heatingId: number;
    heating: string;
    enHeating: string;
    buildingStageStr: string;
    level: number;
    numberOfLevels: string;
    elevator: boolean;
    landNumber: string;
    insuranceCompany?: any;
    buildingStageInt: number;
    bathrooms: number;
    storageRooms: number;
    storageDescription: string;
    gardenDescription: string;
    privateOrOpenSale: boolean;
    isAdvertised: boolean;
    adCounter: number;
    salePercent: number;
    taxPerYear: number;
    waterTax: number;
    insurancePerYear: number;
    monthlyCost: number;
    salesComm: number;
    caption: string;
    renovation: string;
    gallar: string;
    advertising: string;
    openHouseTitle: string;
    openHouseDate: Date;
    openHouseStart: Date;
    openHouseEnd: Date;
    openHouseText: string;
    showAdvertising: boolean;
    showWebsite: boolean;
    inStorage: boolean;
    sentToWeb: boolean;
    inDarkpool: boolean;
    captiondecode?: any;
    advertisingdecode?: any;
    isDeleted: boolean;
    modifiedBy: string;
    modifiedOn: Date;
    swapStmt?: any;
    swapConfig?: any;
    lawnSize: number;
    propertyExchangeAgreement: string;
    groundLeaseAgreement: string;
    deedNo: string;
    userId: string;
    totalPropertySize: number;
    mainPropertyTypeId: number;
    mainPropertyType: string;
    enMainPropertyType: string;
    category: string;
    preemption: boolean;
    totalRooms: number;
    mainRegId: string;
    mhlNhNr: string;
    longitude: number;
    latitude: number;
    watermarkPosition: boolean;
    wmApplyWeb: boolean;
    wmApplyEmail: boolean;
    wmApplyDown: boolean;
    useWmProperty: boolean;
    lastFmrUpdate: Date;
    isSwappable: boolean;
    isFeatured: boolean;
    status: number;
    projectname: string;
    unitcode: string;
    unittype: string;
    contractno: string;
    signingdate?: any;
    contractexpired?: any;
    propertysource?: any;
    houseNumber: string;
    zoneId?: any;
    isProject: boolean;
    companyName: string;
    projectId: number;
    projectUnitId?: any;
    totalUnit?: any;
    remark?: any;
    percentComplete?: any;
    minimumPrice: number;
    propertyUniqueId: string;
    mapSheetNo: string;
    parcelNo: string;
    dealingFileNo: string;
    listingDate: Date;
    jsonTitle: any;
    jsonAddress: any;
    jsonAddress2: any;
    jsonCompanyName: any;
    jsonStorageDescription: any;
    jsonBalconiesDescription: any;
    jsonGardenDescription: any;
    jsonLaundryDescription: any;
    jsonOtherRooms: any;
    jsonAirconditionUnitDescription: any;
    jsonParkingLotDescription: any;
    propertyTypes: any;
    coopStmtDate?: Date;
    airconditionUnit?: number;
    groundfloorMaterial: string;
    parkingLot?: number;
    upfloorMaterial: string;
    isDDLSentToWebDisabled: boolean;
    propertyOwners: ContactDetail[];
}

export interface ContactDetail {
    contactId: string;
    userId: string;
    fullName: string;
    email: string;
    dateEntered: Date;
    address: string;
    mobilePhone: string;
    saleRepresentative: string;
    province: string;
    district: string;
    area: string;
    source?: number;
    status?: number;
    socialSecurityNo: string;
    key: string;
}

export interface PropertyFeature {
    id: string;
    type: string;
    feature: string;
    provinceCode: string;
    districtCode: string;
}

export interface Exclusive {
    name: string;
    value: boolean;
}

export interface PropertyStatus {
    id: number;
    statusName: string;
    needApprove: boolean;
}

export interface PropertyReport {
    id: number;
    reportName: string;
    menthodName: string;
}

export interface PropertyDetailResponse {
    propertyDetail: PropertyDetail;
    yesNoOptions: YesNoOption[];
    buildingMaterials: IDropdownData[];
    insuranceCompanies: IDropdownData[];
    propertyTypes: IDropdownData[];
    oppositePropertyType: IDropdownData[];
    projectNames: IDropdownData[];
    projectUnits: IDropdownData[];
    propertyStatus: PropertyStatus[];
    provinces: Province[];
    districts: District[];
    areas: Area[];
    zones: any[];
    usages: IDropdownData[];
    buildingStages: IDropdownData[];
    delivery: IDropdownData[];
    entrances: IDropdownData[];
    heatings: IDropdownData[];
    windows: IDropdownData[];
    propertyFeatures: PropertyFeature[];
    indexes: IDropdownData[];
    exclusives: Exclusive[];
    propertyStatuses: PropertyStatus[];
    propertySources: IDropdownData[];
    saleAgents: SaleAgent[];
    developers: any;
    reportList: PropertyReport[];
}

export enum UploadType {
    Gallery = 1,
    Video = 2,
    Blueprint = 3,
    File = 4
}

export interface VideoLink {
    id: number;
    propertyId: number;
    title: string;
    url: string;
    dateModified: Date;
    userId: string;
    sequence: number;
}

export interface PropertyPicturesAndFilesDetail {
    propertyPictures: PictureDetail[];
    videoLinks: VideoLink[];
}

export interface WaterMarkSetting {
    watermarkPropertyPosition: number;
    wmPropertyApplyWeb: boolean;
    wmPropertyApplyEmail: boolean;
    wmPropertyApplyDown: boolean;
    useWmProperty: boolean;
    watermarkPosition: number;
    wmApplyWeb: boolean;
    wmApplyEmail: boolean;
    wmApplyDown: boolean;
}

export interface WatermarkPosition {
    text: string;
    value: string;
}

export interface PropertyPictureAndFileResponse {
    propertyPicturesAndFilesDetail: PropertyPicturesAndFilesDetail;
    waterMarkSetting: WaterMarkSetting;
    watermarkPositions: WatermarkPosition[];
    propertyPortals: Portal[];
    sentToWeb: boolean;
}


export interface SelectedPortalProperty {
    propertyId: number;
    portalSenderId: number;
}

export interface PropertyOwnerResponse {
    contacts: any;
    ownerDetail: OwnerDetail;
}

export interface OwnerDetail {
    owners: IBuyerInformation[];
    renters: IBuyerInformation[];
}

export interface PropertyActivityDetail {
    id: number;
    propertyId: number;
    description: string;
    activityDate?: Date;
    agentName: string;
    userId: string;
}

export interface FMRDetailResponse {
    propertyAssets: PropertyAsset[];
    landNumber: string;
    landSize: number;
    streetName: string;
    fmrUrl: string;
}

export interface PropertyDocumentResponse {
    propertyActions: PropertyAction[];
    propertyFiles: PropertyFile[];
    bluePrints: PropertyFile[];
    defaultFileLogo: string;
    defaultPdfLogo: string;
    defaultWordLogo: string;
    defaultExcelLogo: string;
    isRent: boolean;
}

export interface PropertyFile {
    id: number;
    propertyId: number;
    fileName: string;
    fileContent: string;
    type: string;
    thumbnail?:string;
}

export interface PropertyAction {
    actionId: number;
    actionDateTimeStr: string;
    actionName: string;
    agentName: string;
    customerName: string;
    customerId: string;
    key: number;
    actionDateTime: string;
    type: string;
    offerId: number;
    contractId: number;
    deedId: number;
    propertyId: number;
    isHasRelatedDocument: boolean;
}

export interface HistoryChangeDetail {
    fieldName: string;
    recentValue: any;
    currentValue: any;
}

export interface PropertyHistory {
    propertyShwId: number;
    changedDate: Date;
    modifiedUser: string;
    changeDetails: HistoryChangeDetail[];
}

export interface PropertyLoanResponse{
    mortgages: Mortgages[];
    summaryByMortgagee: SummaryByMortgagee[];
    summaryByLoanStatus: SummaryByLoanStatus[];
}

export interface PropertyLoanDetailResponse{
    mortgage: Mortgages;
    currencies: IDropdown[];
    mortgagee:  IDropdown[];
    takeOver: IDropdown[];
    loanIndex: IDropdown[];
    loanType: IDropdown[];
    todayIndex: BaseIndices[];
    exchangeRate: ExchangeRate[];
}


export interface Mortgages{
    loanId: number,
    parentLoanId: number,
    loanCategoryId: number,
    mortgagee: string,
    mortgageRight: number,
    loanNumber: string,
    takeOver : string,
    loanIndex: number,
    indexType: string,
    originalAmount: number,
    loanRemainder: number,
    isLocked: boolean,
    isSent : boolean,
    loanCost: string,
    originalNumberOfPayments: number,
    correction: number,
    paymentsPerYear: number,
    monthlyPayment: number,
    loanStartDate: Date,
    firstPaymentDate: Date,
    nextPaymentDate: Date,
    interest: number,
    remainingPayments: number,
    parentId: number,
    parentType: string,
    isPaymentLocked: boolean,
    paymentCorrection: number,
    notSendToWeb: boolean,
    todayLoanIndex: number,
    loanRemainderForShow : number,
    monthlyPaymentForShow : number,
    lockRemainder: number,
    periodPaymentLockRemainder: number,
    currencies : Currency[],
    
    mortgageeValue: string,
}

export interface SummaryByMortgagee{
    mortgagee: string;
    loanRemainder: number;
}

export interface SummaryByLoanStatus{
    status: string;
    amount: number;
}

export interface Currency{
    id: number,
    icelandicAmount: number,
    foreignAmount: number,
    currencyInterestRate: number,
    remainder: number,
    payment: number,
    name: string,
    exchangeRate: number,
}

export interface BaseIndices{
    id: number,
    type: string
    year: number,
    month: number,
    value: number,
    index: number,
}
export interface ExchangeRate{
    id: number,
    currency: string
    currencyName: number,
    buyingRate: number,
    sellingRate: number,
    currencyDate: Date,
    averageRate: number
}


// WEBPACK FOOTER //
// ./src/redux/sagaProperty/ISagaProperty.ts